import { render, staticRenderFns } from "./ReportPending.vue?vue&type=template&id=48b8951e"
import script from "./ReportPending.vue?vue&type=script&lang=js"
export * from "./ReportPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports